module.exports = __webpack_public_path__ + "img/e-cross-logo-stamp.ff9b20f4.png";